export enum TradesTableViewOption {
  Chart = 'Chart::TradesTableViewOption',
  Table = 'Table::TradesTableViewOption',
}

export const next: Record<TradesTableViewOption, TradesTableViewOption> = {
  [TradesTableViewOption.Chart]: TradesTableViewOption.Table,
  [TradesTableViewOption.Table]: TradesTableViewOption.Chart,
}
